import { render, staticRenderFns } from "./RepresentantesLista.vue?vue&type=template&id=66d7278a&scoped=true&"
import script from "./RepresentantesLista.vue?vue&type=script&lang=js&"
export * from "./RepresentantesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7278a",
  null
  
)

export default component.exports